(() => {
  'use strict';

  const SELECTOR = { button: '.c_back-to-top' };
  const CLASS_VISIBLE = 'is-visible';

  function initButton(button) {
    const showAfter = parseInt(button.dataset.showAfter, 10) || 300;

    const update = () => {
      button.classList.toggle(CLASS_VISIBLE, window.scrollY > showAfter);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });

    button.addEventListener('click', () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  document.querySelectorAll(SELECTOR.button).forEach(initButton);

  document.addEventListener('shopify:section:load', (event) => {
    const button = event.target.querySelector(SELECTOR.button);
    if (button) initButton(button);
  });
})();
